module.exports = __webpack_public_path__ + "fonts/Inter-800-latin-ext76.1ad231a.woff2";